export enum IdeasTabKeys {
  TRENDING = 'trend',
  LATEST = 'latest',
  TOP_VOTED = 'voted',
  RANDOM = 'random',
  MOST_DISCUSSED = 'commented'
}
